"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFederatedModuleFallbackServers = void 0;
/**
 * Finds CDN fallback servers for the given URL.
 *
 * @param mappings Configured CDN fallback mappings
 * @param url The URL to get the fallback servers for
 * @returns An array of fallback servers for the given URL or an empty array if no fallback servers are configured.
 */
function getFederatedModuleFallbackServers(mappings, url) {
    const parsedUrl = new URL(url);
    const hostUrl = new URL(`${parsedUrl.protocol}//${parsedUrl.host}`);
    if (parsedUrl.port) {
        hostUrl.port = parsedUrl.port;
    }
    const hostUrlString = hostUrl.toString();
    const mapping = mappings.find((mapping) => new URL(mapping.primary).toString() === hostUrlString);
    return mapping?.fallbacks ?? [];
}
exports.getFederatedModuleFallbackServers = getFederatedModuleFallbackServers;
